import { I621Form } from 'legacy/lut/features/partner360/configuration'
import { IMarketSector } from 'legacy/lut/features/partner360/marketInfo'

export const map621ToMarketSector = (data: I621Form): IMarketSector => {
  return {
    isPercentMode: data.MarketSectorShowPercent === 1,
    public: data.MarketSectorPublic || 0,
    middleMarket: data.MarketSectorMiddleMarket || 0,
    enterprise: data.MarketSectorEnterprise || 0,
    smb: data.MarketSectorSMB || 0,
    smbManaged: data.MarketSectorSMBManaged || 0,
    smbUnmanaged: data.MarketSectorSMBUnmanaged || 0,
    corporate: data.MarketSectorCorporate || 0,
  }
}
